import { combineReducers } from 'redux';
import playerReducer from './modules/Player/reducer';
import appReducer from './App/reducer';

import { COMPONENT_NAME as PLAYER_NAMESPACE } from './modules/Player/constants';
import { COMPONENT_NAME as APP_NAMESPACE } from './App/constants';

const rootReducer = combineReducers({
  [PLAYER_NAMESPACE]: playerReducer,
  [APP_NAMESPACE]: appReducer,
});

export default rootReducer;
